/*
 * File: /src/router/routes/callTypeDetails.js
 * Created Date: Monday August 17th 2026
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */

const CallTypeDetails = () =>
  import(
    /* webpackChunkName: "CallTypeDetail" */ 'src/components/Dashboard/Views/CallTypeDetails/CallTypeDetailList.vue'
  );

const EditCallTypeDetail = () =>
  import(
    /* webpackChunkName: "CallTypeDetail" */ 'src/components/Dashboard/Views/CallTypeDetails/CallTypeDetailEdit.vue'
  );

export const callTypeDetailRoutes = [
  {
    path: 'call-type-details/',
    name: 'Call Type Details',
    component: CallTypeDetails,
  },
  {
    path: 'call-type-details/add',
    name: 'Add New Call Type Detail',
    component: EditCallTypeDetail,
  },
  {
    path: 'call-type-details/edit/:id',
    name: 'Edit Call Type Detail',
    component: EditCallTypeDetail,
  },
];
